import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { Logo } from '@assets/icons';
import { Container, LogoContainer } from './ProductSelectionDialogHeader.styles';
import { ProductSelectionDialogHeaderProps } from './ProductSelectionDialogHeader.types';

export const ProductSelectionDialogHeader: React.FC<ProductSelectionDialogHeaderProps> = ({ title, subtitle }) => {
  return (
    <Container>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <TextV2 typographyVariant="hed4" textAlign="center">
        {title}
      </TextV2>
      <TextV2 typographyVariant="body1" textAlign="center">
        {subtitle}
      </TextV2>
    </Container>
  );
};
